import { CheveronDownIcon, PersonIcon } from '@wkda/icons';
import cx from 'classnames';
import { useEffect, useRef, useState } from 'react';
import NavMenu from '../NavMenu';
import Paper from '../Paper';
import UserNavMenu from '../UserNavMenu';
import VerticalNavMenu, { ItemTitle } from '../VerticalNavMenu';
import { useMediaQuery } from '../hooks/useMediaQuery';
import { AccountMenu } from './AccountMenu';
import MenuIcon from './MenuIcon';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function Header(_ref) {
  let {
    navList,
    logo,
    LinkComponent = 'a',
    MenuText = 'MENÜ',
    pageUrl,
    ...rest
  } = _ref;
  const navNode = useRef(null);
  const mobileNavNode = useRef(null);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [userNavList, logoutItem] = filterAndGetLogoutItem(rest.hasUserAccount === true ? rest.userNavList : undefined);

  // Bootstrap breakpoint for lg
  const isLargeScreen = useMediaQuery('(min-width: 992px)');
  useEffect(function pageUrlChangeEffect() {
    setIsMobileNavOpen(false);
  }, [pageUrl]);
  useEffect(function largeScreenEffect() {
    setIsMobileNavOpen(false);
  }, [isLargeScreen]);
  const accountItem = rest.hasUserAccount ? rest.userIsLoggedIn ? rest.loggedInItem : rest.loginItem : undefined;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "wa-header__root",
      children: [/*#__PURE__*/_jsx("header", {
        className: cx('wa-header', {
          'wa-header--open': isMobileNavOpen
        }),
        children: /*#__PURE__*/_jsx("div", {
          className: "container wa-header__container",
          children: /*#__PURE__*/_jsxs("div", {
            className: "wa-header__content",
            children: [/*#__PURE__*/_jsx(LinkComponent, {
              href: "/",
              className: cx('wa-header__logo', {
                'wa-header__logo-hidden': isMobileNavOpen
              }),
              children: /*#__PURE__*/_jsx("img", {
                className: 'img-fluid',
                src: logo.src,
                alt: logo.alt
              })
            }), /*#__PURE__*/_jsx("span", {
              className: cx('wa-header__menu-text', {
                'wa-header__menu-text-hidden': !isMobileNavOpen
              }),
              children: MenuText
            }), /*#__PURE__*/_jsx("nav", {
              className: "wa-header__nav",
              children: /*#__PURE__*/_jsx("ul", {
                ref: navNode,
                className: "wa-header__list",
                children: renderNavListItems(navList)
              })
            }), accountItem ? /*#__PURE__*/_jsx("div", {
              className: "wa-header__login-btn-wrapper",
              children: /*#__PURE__*/_jsxs(LinkComponent, {
                href: accountItem.link,
                className: "wa-header__login-btn",
                children: [!accountItem.hideIcon && /*#__PURE__*/_jsx(PersonIcon, {}), /*#__PURE__*/_jsx("span", {
                  className: "wa-header__login-user-text",
                  children: accountItem.title
                })]
              })
            }) : null, /*#__PURE__*/_jsx("button", {
              type: "button",
              ref: mobileNavNode,
              className: cx('wa-header__toggle-btn'),
              onClick: toggleMobileNav,
              children: /*#__PURE__*/_jsx(MenuIcon, {
                isOpen: isMobileNavOpen,
                text: MenuText
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsxs(Paper, {
        isElevated: true,
        isFixedTop: true,
        className: cx('wa-header__mobile-nav', {
          'wa-header__mobile-nav--open': isMobileNavOpen
        }),
        children: [/*#__PURE__*/_jsx(VerticalNavMenu, {
          LinkComponent: LinkComponent,
          navList: navList
        }), rest.hasUserAccount ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [rest.userIsLoggedIn && userNavList ? /*#__PURE__*/_jsx(UserNavMenu, {
            className: "wa-nav-item-separator",
            LinkComponent: LinkComponent,
            navList: userNavList
          }) : null, /*#__PURE__*/_jsx(AccountMenu, {
            isLoggedIn: rest.userIsLoggedIn ?? false,
            accountItem: accountItem,
            logoutItem: logoutItem,
            LinkComponent: LinkComponent
          })]
        }) : null]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: cx('wa-header__overlay', {
        'wa-header__overlay--open': isMobileNavOpen
      }),
      onClick: toggleMobileNav
    })]
  });
  function renderNavListItems(navList) {
    return navList.map((item, key) => {
      const hasDropDowns = itemHasDropDowns(item);
      return /*#__PURE__*/_jsxs("li", {
        className: cx('wa-header__list-item', {
          'wa-header__list-item--dropdown': hasDropDowns
        }),
        children: [item.link ? /*#__PURE__*/_jsx(LinkComponent, {
          className: "wa-header__list-item-link",
          href: item.link,
          children: /*#__PURE__*/_jsx(ItemTitle, {
            ...item
          })
        }) : /*#__PURE__*/_jsxs("span", {
          className: "wa-header__list-item-text",
          children: [/*#__PURE__*/_jsx(ItemTitle, {
            ...item
          }), hasDropDowns ? /*#__PURE__*/_jsx(CheveronDownIcon, {
            className: cx('wa-header__chevron')
          }) : null]
        }), hasDropDowns ? /*#__PURE__*/_jsx(NavMenu, {
          LinkComponent: LinkComponent,
          dropdowns: item.dropDowns,
          className: "wa-header__dropdown"
        }) : null]
      }, key);
    });
  }
  function toggleMobileNav(_) {
    setIsMobileNavOpen(prevState => !prevState);
  }
  function itemHasDropDowns(item) {
    return item.dropDowns != null && item.dropDowns.length > 0;
  }
}
function filterAndGetLogoutItem() {
  let items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let logoutItem;
  let filteredItems = [];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item !== undefined && 'link' in item && item?.link?.includes('logout')) {
      logoutItem = item;
    } else {
      if (item) {
        filteredItems.push(item);
      }
    }
  }
  return [filteredItems, logoutItem];
}